/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonChangeOfobject,
    JsonChangeOfobjectFromJSON,
    JsonChangeOfobjectFromJSONTyped,
    JsonChangeOfobjectToJSON,
} from './JsonChangeOfobject';

/**
 * 
 * @export
 * @interface JsonInviteReplyDay
 */
export interface JsonInviteReplyDay {
    /**
     * 
     * @type {Array<string>}
     * @memberof JsonInviteReplyDay
     */
    allowedActions?: Array<JsonInviteReplyDayAllowedActionsEnum>;
    /**
     * 
     * @type {Array<JsonChangeOfobject>}
     * @memberof JsonInviteReplyDay
     */
    changes?: Array<JsonChangeOfobject>;
    /**
     * 
     * @type {string}
     * @memberof JsonInviteReplyDay
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof JsonInviteReplyDay
     */
    createdBy?: number;
    /**
     * 
     * @type {string}
     * @memberof JsonInviteReplyDay
     */
    dayDate?: string;
    /**
     * 
     * @type {number}
     * @memberof JsonInviteReplyDay
     */
    dayNo?: number;
    /**
     * 
     * @type {boolean}
     * @memberof JsonInviteReplyDay
     */
    isParking?: boolean;
    /**
     * 
     * @type {number}
     * @memberof JsonInviteReplyDay
     */
    replyDayId?: number;
    /**
     * 
     * @type {number}
     * @memberof JsonInviteReplyDay
     */
    replyId?: number;
    /**
     * 
     * @type {string}
     * @memberof JsonInviteReplyDay
     */
    replyType?: JsonInviteReplyDayReplyTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof JsonInviteReplyDay
     */
    updatedAt?: string;
    /**
     * 
     * @type {number}
     * @memberof JsonInviteReplyDay
     */
    updatedBy?: number;
}

/**
* @export
* @enum {string}
*/
export enum JsonInviteReplyDayAllowedActionsEnum {
    View = 'VIEW',
    Edit = 'EDIT'
}/**
* @export
* @enum {string}
*/
export enum JsonInviteReplyDayReplyTypeEnum {
    Accept = 'ACCEPT',
    Reject = 'REJECT'
}

export function JsonInviteReplyDayFromJSON(json: any): JsonInviteReplyDay {
    return JsonInviteReplyDayFromJSONTyped(json, false);
}

export function JsonInviteReplyDayFromJSONTyped(json: any, ignoreDiscriminator: boolean): JsonInviteReplyDay {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'allowedActions': !exists(json, 'allowedActions') ? undefined : json['allowedActions'],
        'changes': !exists(json, 'changes') ? undefined : ((json['changes'] as Array<any>).map(JsonChangeOfobjectFromJSON)),
        'createdAt': !exists(json, 'createdAt') ? undefined : json['createdAt'],
        'createdBy': !exists(json, 'createdBy') ? undefined : json['createdBy'],
        'dayDate': !exists(json, 'dayDate') ? undefined : json['dayDate'],
        'dayNo': !exists(json, 'dayNo') ? undefined : json['dayNo'],
        'isParking': !exists(json, 'isParking') ? undefined : json['isParking'],
        'replyDayId': !exists(json, 'replyDayId') ? undefined : json['replyDayId'],
        'replyId': !exists(json, 'replyId') ? undefined : json['replyId'],
        'replyType': !exists(json, 'replyType') ? undefined : json['replyType'],
        'updatedAt': !exists(json, 'updatedAt') ? undefined : json['updatedAt'],
        'updatedBy': !exists(json, 'updatedBy') ? undefined : json['updatedBy'],
    };
}

export function JsonInviteReplyDayToJSON(value?: JsonInviteReplyDay | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'allowedActions': value.allowedActions,
        'changes': value.changes === undefined ? undefined : ((value.changes as Array<any>).map(JsonChangeOfobjectToJSON)),
        'createdAt': value.createdAt,
        'createdBy': value.createdBy,
        'dayDate': value.dayDate,
        'dayNo': value.dayNo,
        'isParking': value.isParking,
        'replyDayId': value.replyDayId,
        'replyId': value.replyId,
        'replyType': value.replyType,
        'updatedAt': value.updatedAt,
        'updatedBy': value.updatedBy,
    };
}

